import styled from '@emotion/styled'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'
import OfficialCommonBtn from '../atoms/officialCommonBtn'
import ArrowSvg from '../atoms/arrowSvg'
import useRouteParam from '../../hooks/useRouteParam'

const Wrapper = styled.article`
  display: flex;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
  text-align: center;
  margin-bottom: 60px;
  border: solid 2px #bef1e5;
  border-radius: 5px;
  padding: 20px;
  position: relative;

  .intro-wrap {
    background-color: #35d4c7;
    position: absolute;
    padding: 10px 20px;
    left: -10px;
    top: 15px;
  }

  .intro-txt {
    font-size: 18px;
    line-height: 1;
    color: #fff;
    font-weight: 600;
    margin: 0;
    padding: 0;
  }

  .detail-txt {
    line-height: 24px;
    margin-top: 45px;
    margin-bottom: 15px;
    padding: 0;
  }

  .btn-wrap {
    display: flex;
    width: 100%;
    justify-content: center;

    button {
      height: 60px;
      margin: 0;
    }

    .btn-inner {
      display: flex;
      align-items: center;
      justify-content: center;

      p {
        padding: 0;
        margin-right: 10px;
        font-size: 23px;
      }
    }
  }

  ${BreakPoints.large} {
  }
`

/**
 * コラム記事詳細：製品誘導案(AB)
 * @constructor
 */
const Introduction005 = () => {
  const routeParam = useRouteParam('https://www.kintaicloud.jp/')
  const routeParam2 = useRouteParam(
    'https://sign-up.kintaicloud.jp/sign-up/?utm_source=article&utm_medium=post&utm_campaign=pattern_02_IN'
  )
  return (
    <>
      <a href={routeParam} className="column-detail-link">
        ⇒ 勤怠管理システム「キンクラ」について詳しく知りたい方はここをクリック
      </a>
      <Wrapper>
        <div className="intro-wrap">
          <p className="intro-txt">勤怠システム、まずは使ってみませんか？</p>
        </div>
        <p className="detail-txt">
          勤怠管理システム「キンクラ」は全ての機能を
          <br />
          最大2ヵ月無料でお試しいただけます。
          <br />
          １分で簡単登録！すぐにお試しいただけます。
        </p>
        <div className="btn-wrap">
          <OfficialCommonBtn
            size="mega"
            level="strong"
            onClick={() => window.open(routeParam2)}
            className="strong-btn"
          >
            <div className="btn-inner">
              <p>無料トライアル</p>
              <ArrowSvg />
            </div>
          </OfficialCommonBtn>
        </div>
      </Wrapper>
    </>
  )
}

export default Introduction005
